var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"editRecord"},[_c('page-header',{attrs:{"title":_vm.title}}),_c('div',{staticClass:"content"},[_c('write',{attrs:{"formData":_vm.formData},on:{"efficacyTrackSave":_vm.efficacyTrackSave}})],1),_c('prev-page',{attrs:{"text":'返回看记录'},on:{"back":_vm.back}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }